const handleDeleteServiceModalEquipService = {
  confirm: '¿Realmente desea eliminar el servicio?',
  title: 'ELIMINAR SERVICIO'
};

export default handleDeleteServiceModalEquipService;
